import { Box, Card, CardContent, Container, Grid, Typography } from '@mui/material';
import img0 from "../../utils/images/aboutUs.jfif";
import img1 from "../../utils/images/aboutUs1.JPG";
import img2 from "../../utils/images/aboutUs2.jfif";
import React from "react";
import { Navbar } from "../../components/Navbar/Navbar";
import Button from '@mui/material/Button';
import Ticker from 'react-ticker';

import Tickers from "../../components/Tickers/Tickers";


import Footer from "../../components/Footer/Footer";



import { useNavigate } from 'react-router-dom';
const Blogs = () => {
  const navigate = useNavigate();

  return (
    <div>
      <Navbar />
      {/* <Ticker style={{ backgroundColor: '#333333', }} >
        {({ index }) => (
          <>
            <div style={{ backgroundColor: "#FF7345", marginTop: "70px", color: "white", width: '200px' }}>
              <Typography sx={{ fontFamily: "Sora", marginRight: 2, lineHeight: 2.5, marginRight: '28px', }}>
                Sample News <></>
              </Typography>
            </div>
          </>
        )}
      </Ticker> */}
      {/* <Tickers></Tickers> */}
      <div
        style={{
          width: "100%",
          display: "flex",
          height: "457px",
          paddingTop: "100px",
          background: `rgba(0, 0, 0,0.8) url(${img0})`,

          backgroundSize: "cover",
          position: "relative",
          backgroundPosition: "center",
          zIndex: -1,
          flexDirection: "column",
          backgroundBlendMode: "darken",

          // marginTop: "20px",

        }}
      >

        {/* <Typography
          variant="h2"
          sx={{
            fontFamily: "Sora",
            color: "#FCFCFC",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            marginTop: "80px",
            marginLeft: "90px",
            fontWeight: "bold",
            textAlign:'center',
          }}
        >
          Uwp Blogs
        </Typography> */}
        <Typography
          // variant="h2"
          sx={{
            fontFamily: "Poppins",
            color: "#FFFFFF",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            margin: "100px auto",
            fontWeight: "bold",
            fontSize: "3.2rem",
            // font: '50pt',

          }}
        >
          Uwp Blogs
        </Typography>
        {/* <Typography
          variant="h4"
          sx={{
            fontFamily: "Sora",
            color: "white",
            justifyContent: "center",
            width: "100%",
            display: "flex",
            fontWeight: "bold",
            fontSize: ["20px", "30px", "30px"]

          }}
        >
        </Typography> */}
      </div>
      <Typography
        variant="h5"
        sx={{
          display: "flex",
          width: "100%",
          fontFamily: "Sora",
          justifyContent: "center",
          color: "#FF7345",
          fontWeight: "bold",
          marginTop: 4
        }}
      >
        Latest Blogs
      </Typography>

      <Box sx={{ flexGrow: 1, px: [0, 0, 0, 5], marginTop: 2 }}>
        <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }} >
          <Box sx={{ display: "flex", px: [0, 0, 0], marginTop: 2 }}>
            <CardContent sx={{ width: '60%' }}>
              <img
                style={{
                  width: "30vw",
                  height: "40vh",

                }}
                src={img2}
              />
              <br />
              <Typography
                sx={{
                  color: 'var(--unnamed-color-223230)',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                  marginTop: '10px',
                  opacity: 0.67,
                }}
              >

                Department: School of Public Health
              </Typography>
              <Typography
                sx={{
                  color: '#223230',
                  fontFamily: 'Sora',
                  fontSize: '21px',
                  width: '100%',
                  fontWeight: '600',
                  textAlign: 'justify'
                }}
              >

                Social interactions and relationships in college
              </Typography>
              {/* <Typography
                sx={{
                  color: ' #223230',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                }}
              >

                1.1 By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day...
              </Typography> */}
              <br />
              <Button variant="outlined" sx={{ color: '#FF7345', border: `1px solid #FF7345`, "&:hover": { border: `1px solid #f83d0085` } }} onClick={() => {
                navigate('/readArticles');
              }}>Read Articles</Button>
            </CardContent>
            {/* <CardContent sx={{ width: '60%' }}>
              <img
                style={{
                  width: "30vw",
                  height: "40vh",
                }}
                src={img2}
              />
              <br />
              <Typography
                sx={{
                  color: 'var(--unnamed-color-223230)',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                  marginTop: '10px',
                  opacity: 0.67,
                }}
              >

                Department: School of Public Health
              </Typography>
              <Typography
                sx={{
                  color: '#223230',
                  fontFamily: 'Sora',
                  fontSize: '20px',
                  width: '100%',
                  fontWeight: '600',
                  letterSpacing: 0
                }}
              >

                Social interactions and relationships in college
              </Typography>
              <Typography
                sx={{
                  color: ' #223230',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                }}
              >

                1.1 By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day...
              </Typography>
              <br />
              <Button variant="outlined" sx={{ color: '#FF7345', border: `1px solid #FF7345`, "&:hover": { border: `1px solid #f83d0085` } }}
                onClick={() => {
                  navigate('/readArticles');
                }}>Read Articles</Button>
            </CardContent> */}
            {/* <Box>

              <Typography
                sx={{
                  color: '#223230',
                  fontFamily: 'Sora',
                  fontSize: '20px',
                  width: '100%',
                  fontWeight: '600',
                  letterSpacing: 0
                }}
              >

                Social interactions and relationships in college
              </Typography>
              <Typography
                sx={{
                  color: ' #223230',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                }}
              >

                1.1 By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day...
              </Typography>
              <Typography
                sx={{
                  color: '#FF7345',
                  fontSize: '17px'
                }}
              >
                <u>Read Articles</u>
              </Typography>
              <br />

              <Typography
                sx={{
                  color: '#223230',
                  fontFamily: 'Sora',
                  fontSize: '20px',
                  width: '100%',
                  fontWeight: '600',
                  letterSpacing: 0
                }}
              >

                Social interactions and relationships in college
              </Typography>
              <Typography
                sx={{
                  color: ' #223230',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                }}
              >

                1.1 By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day...
              </Typography>
              <Typography
                sx={{
                  color: '#FF7345',
                  fontSize: '17px'
                }}
              >
                <u>Read Articles</u>
              </Typography>
              <br />

              <Typography
                sx={{
                  color: '#223230',
                  fontFamily: 'Sora',
                  fontSize: '20px',
                  width: '100%',
                  fontWeight: '600',
                  letterSpacing: 0
                }}
              >

                Social interactions and relationships in college
              </Typography>
              <Typography
                sx={{
                  color: ' #223230',
                  fontFamily: 'Sora',
                  fontSize: '13px',
                  width: '90%',
                }}
              >

                1.1 By 2030, eradicate extreme poverty for all people everywhere, currently measured as people living on less than $1.25 a day...
              </Typography>
              <Typography
                sx={{
                  color: '#FF7345',
                  fontSize: '17px'
                }}
              >
                <u>Read Articles</u>
              </Typography>
            </Box> */}
          </Box>
        </Grid >

        {/* <Grid container spacing={{ xs: 2, md: 3 }} columns={{ xs: 12, sm: 12, md: 12 }}>
          {Array.from(Array(6)).map((_, index) => (
            <Grid item xs={12} sm={12} md={6} key={index} sx={{ display: "flex", justifyContent: "center", my: 2 }}>
              <Card
                sx={{ marginBottom: 2, boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px', height: '100%', width: '330px', marginRight: 1, display: 'flex' }}
              >
                <Container sx={{ display: "flex", justifyContent: "center", width: "120%", height: "100%" }}>
                  <Card sx={{ boxShadow: 'rgba(33, 35, 38, 0.1) 0px 10px 10px -10px', display: "flex", justifyContent: "center", flexDirection: "row", height: "30%", width: "100%", marginTop: 5, paddingTop: 3, fontFamily: "Sora", color: "#FF7345", fontSize: "20px" }}>
                    12 JAN
                  </Card>
                </Container>
                <div>

                  <CardContent sx={{}}>
                    <Typography sx={{ color: '#FF7345', fontFamily: 'Sora' }}>Sub Heading</Typography>
                    <Typography
                      sx={{
                        color: ' #62392B',
                        fontFamily: 'Sora',
                        fontSize: '13px',
                      }}
                    >
                      Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore
                      et dolore magna aliqua.
                    </Typography>
                  </CardContent>
                </div>
              </Card>
            </Grid>
          ))}
        </Grid> */}
      </Box >
      <Footer></Footer>
    </div >

  );
};

export default Blogs;
